import { useEffect, useState } from 'react';
import { FormattedNumber } from 'react-intl';

type Props = {
  countPart: string;
  placeholder?: React.ReactNode;
};

export function CountResolver({ countPart, placeholder }: Props) {
  if (isAbsoluteEndpoint(countPart) || isRelativeEndpoint(countPart)) {
    return <CountFetcher countPart={countPart} placeholder={placeholder} />;
  }

  return <FormattedNumber value={Number(countPart)} />;
}

function CountFetcher({ countPart, placeholder }: Props) {
  const [count, setCount] = useState<string | null>(null);

  useEffect(() => {
    // just keep as is. We have ported the resource API. If any other old proxy APIs was used, they should instead use our official stable ones
    // previously we tried to rewrite this
    const endpoint = countPart;

    fetch(endpoint)
      .then((response) => response.json() as Promise<unknown>)
      .then((result) => {
        const count = extractCountFromResult(result);
        setCount(count);
      })
      .catch((error) => console.error(error));
  }, [countPart]);

  if (count === null) {
    return placeholder;
  }

  return <FormattedNumber value={Number(count)} />;
}

const isAbsoluteEndpoint = (countPart: string) => countPart.startsWith('http');

const isRelativeEndpoint = (countPart: string) => countPart.startsWith('/api/');

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const extractCountFromResult = (result: unknown): string | null => {
  if (!isObject(result)) return null;
  if ('count' in result && typeof result.count === 'number') {
    return result.count.toString();
  }
  if (
    'documents' in result &&
    isObject(result.documents) &&
    'total' in result.documents &&
    typeof result.documents.total === 'number'
  ) {
    return result.documents.total.toString();
  }
  return null;
};
